import React from 'react';
import { MessageCircle } from 'lucide-react';
interface WhatsAppButtonProps {
  label: string;
  href: string;
}
function WhatsAppButton({
  label,
  href
}: WhatsAppButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-2 justify-end" aria-label={`WhatsApp ${label}`} data-id="element-236">
      <span className="bg-white/95 text-gray-800 text-xs font-semibold px-3 py-1.5 rounded-full shadow-md whitespace-nowrap" data-id="element-237">
        {label}
      </span>
      <span className="bg-[#25D366] text-white p-3 rounded-full shadow-lg group-hover:scale-110 transition-transform flex items-center justify-center flex-shrink-0" data-id="element-238">
        <MessageCircle size={26} data-id="element-239" />
      </span>
    </a>;
}
export function StickyButtons() {
  return <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end" data-id="element-240">
      <WhatsAppButton label="Blu Ocean Tours" href="https://wa.link/qca29f" data-id="element-241" />
      <WhatsAppButton label="Sweet & Salty" href="https://wa.link/ip0tbk" data-id="element-242" />
    </div>;
}